"use client";

import { TypeEmbedCodeComponent } from "@contentful/types";
import { Document } from "@contentful/rich-text-types";
import sanitizeHtml from "sanitize-html";

function extractTextFromDocument(document: Document): string {
  let text = "";

  function traverse(node: any) {
    if (node.nodeType === "text") {
      text += node.value;
    }
    if (node.content && Array.isArray(node.content)) {
      node.content.forEach((child: any) => traverse(child));
    }
  }

  traverse(document);
  return text;
}

export function EmbedCodeComponent({
  embedCodeComponent,
}: {
  embedCodeComponent: TypeEmbedCodeComponent<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const code = embedCodeComponent.fields.code;

  if (!code) {
    return null;
  }

  const embedCode = extractTextFromDocument(code);

  if (!embedCode.trim()) {
    return null;
  }

  const sanitizedCode = sanitizeHtml(embedCode, {
    allowedTags: [
      "iframe",
      "div",
      "span",
      "a",
      "img",
      "p",
      "br",
      "strong",
      "em",
      "style",
    ],
    allowedAttributes: {
      iframe: [
        "src",
        "width",
        "height",
        "frameborder",
        "allow",
        "allowfullscreen",
        "title",
        "loading",
      ],
      div: ["class", "id", "style"],
      span: ["class", "id", "style"],
      a: ["href", "target", "rel", "class"],
      img: ["src", "alt", "width", "height", "class", "loading"],
    },
    allowedSchemes: ["http", "https"],
    allowedIframeHostnames: [
      "www.youtube.com",
      "player.vimeo.com",
      "cdn.giftup.app",
    ],
  });

  return (
    <div className="mx-auto w-full max-w-7xl px-8 py-12 md:py-24">
      <div
        dangerouslySetInnerHTML={{ __html: sanitizedCode }}
        className="w-full"
      />
    </div>
  );
}
